import { render, staticRenderFns } from "./copyLink.vue?vue&type=template&id=77bf9e57"
import script from "./copyLink.vue?vue&type=script&lang=js"
export * from "./copyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports